var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 47,
    viewBox: "0 0 108 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.046 34.9979C79.8008 18.7385 89.8109 7.87356 105.998 7.0503C107.101 6.9942 108 7.91256 108 9.01712C107.985 36.4396 107.369 36.9893 81.0153 36.9998C79.9107 37.0002 78.9947 36.1013 79.046 34.9979Z",
    className: "Mouth"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00211 7.04597C18.2615 7.80082 29.1264 17.8109 29.9497 33.9976C30.0058 35.1008 29.0874 36.0002 27.9829 35.9997C0.560398 35.9852 0.010727 35.3688 0.000202717 9.01525C-0.000237781 7.91068 0.898732 6.99474 2.00211 7.04597Z",
    className: "Mouth"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0075 15.0138C48.873 15.4407 69.5534 25.7623 70.9271 44.0362C71.0088 45.1235 70.0887 46.0166 68.9985 46.0363C17.1536 46.9743 16.0251 46.6233 16.0006 17.0198C15.9997 15.9152 16.903 14.9985 18.0075 15.0138Z",
    className: "Mouth"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9925 15.0138C60.127 15.4407 39.4466 25.7623 38.0729 44.0362C37.9912 45.1235 38.9113 46.0166 40.0015 46.0363C91.8464 46.9743 92.9749 46.6233 92.9994 17.0198C93.0003 15.9152 92.097 14.9985 90.9925 15.0138Z",
    className: "Mouth"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1074 1.99837C48.3202 13.1048 59.7417 20.4736 77.999 20.9729C79.1032 21.0031 80.0008 20.1019 79.9988 18.9973C79.9654 0.327625 78.9649 0.00530433 49.0211 8.16927e-05C47.9165 -0.000110961 46.9875 0.900333 47.1074 1.99837Z",
    className: "Mouth"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8894 1.99812C60.6386 13.1167 48.8468 20.4896 30.0003 20.9745C28.8961 21.0029 27.9992 20.1019 28.0012 18.9973C28.0357 0.315529 29.0678 0.00489425 59.9777 7.21456e-05C61.0822 -9.95273e-05 62.0129 0.90047 61.8894 1.99812Z",
    className: "Mouth"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthO);
export default __webpack_public_path__ + "static/media/Mouth O.5a04e4e600f8aacfb4ca4a4331c24826.svg";
export { ForwardRef as ReactComponent };